import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }

    // remove tudo que não for número
    value = value.replace(/\D/g, '');

    // verifica se tem pelo menos 11 dígitos
    if (value.length < 11) {
      return value;
    }

    // adiciona a máscara de telefone
    return value.replace(/^(\d{2})(\d{1})(\d{4})(\d{4}).*/, '($1) $2 $3-$4');
  }

}
